import axios from 'axios'

const instance = axios.create({
  baseURL: process.env.API_URL,
  timeout: 10000
})

instance.interceptors.request.use(
  config => {
    config.headers['auth-token'] = localStorage.getItem('auth-token')
    return config
  }, error => {
    console.error(error)
    return Promise.reject(error)
  }
)

instance.interceptors.response.use(
  response => {
    const statusCode = response.status
    if (statusCode === 401 || statusCode === 403) {
      console.error('网页未授权')
      return Promise.reject(response)
    }
    if (statusCode === 500) {
      console.error('服务端失败')
      return Promise.reject(response)
    }
    if (statusCode !== 200) {
      return Promise.reject(response)
    }
    return response.data
  }, error => {
    console.error(error)
    alert('网络错误 接口可能未实现' + error)
    return Promise.reject(error)
  }
)

export default instance



// WEBPACK FOOTER //
// ./src/lib/utils.js